export default __webpack_public_path__ + "static/media/Group 12457.01d28b53.png";